import { render, staticRenderFns } from "./GrHtmlSpan.vue?vue&type=template&id=2edac61f&"
import script from "./GrHtmlSpan.vue?vue&type=script&lang=ts&"
export * from "./GrHtmlSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GrHtmlSpan.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports